/*
  Boston Breaks cart page (Phase E).
  - The − / + buttons step the quantity (never below 0 or above the input's max).
  - Any quantity change submits the cart form with "update", so totals are always Shopify's
    own numbers. Without script, the "Update cart" button does the same.
*/
(function () {
  'use strict';

  var form = document.querySelector('[data-bb-cart-form]');
  if (!form) return;

  var updateButton = form.querySelector('[data-bb-cart-update]');
  var timer = null;

  function submitUpdate() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      form.classList.add('is-updating');
      if (updateButton && typeof form.requestSubmit === 'function') {
        form.requestSubmit(updateButton);
      } else if (updateButton) {
        updateButton.click();
      } else {
        form.submit();
      }
    }, 450);
  }

  function clamp(input, value) {
    var min = input.min === '' ? 0 : parseInt(input.min, 10);
    var max = input.max === '' ? Infinity : parseInt(input.max, 10);
    if (isNaN(value)) value = min;
    return Math.min(Math.max(value, min), max);
  }

  form.addEventListener('click', function (event) {
    var step = event.target.closest('[data-bb-qty-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('[data-bb-qty]');
    if (!input) return;
    var next = clamp(input, parseInt(input.value, 10) + parseInt(step.getAttribute('data-bb-qty-step'), 10));
    if (String(next) === input.value) return;
    input.value = next;
    submitUpdate();
  });

  form.addEventListener('change', function (event) {
    if (!event.target.matches('[data-bb-qty]')) return;
    event.target.value = clamp(event.target, parseInt(event.target.value, 10));
    submitUpdate();
  });

  // Enter in a quantity box updates the cart instead of going to checkout.
  form.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches('[data-bb-qty]')) {
      event.preventDefault();
      event.target.value = clamp(event.target, parseInt(event.target.value, 10));
      submitUpdate();
    }
  });
})();
